import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_tac" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_3 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_4 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "_flexcol _jc-c _gap-1" }
const _hoisted_7 = { class: "_pt-1" }
const _hoisted_8 = { class: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" }
const _hoisted_9 = { class: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" }
const _hoisted_10 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_box = _resolveComponent("box")
  const _component_base_quote = _resolveComponent("base-quote")
  const _component_why_gamefound_project_explorer = _resolveComponent("why-gamefound-project-explorer")
  const _component_platform_feature_comparison = _resolveComponent("platform-feature-comparison")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_container = _resolveComponent("base-container")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.WhyGamefoundLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _createVNode(_component_base_hero, {
        title: "Why Gamefound?",
        description: "From funding to fulfillment, Gamefound gives you powerful tools, expert insights, and a passionate community — so your campaign can go further.",
        type: "whyGamefound"
      }),
      _createVNode(_component_base_container, {
        width: "narrow",
        class: "_flexcol _gap-6 _py-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_box, {
            class: "_flexcol _gap-6",
            huge: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString($options.ecoSystem.title), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_3, _toDisplayString($options.ecoSystem.subtitle), 1 /* TEXT */)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ecoSystem.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.icon,
                  class: "_flex _gap-3"
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_base_icon, {
                      name: item.icon,
                      "icon-namespace": item.iconNameSpace,
                      "is-fixed-width": "",
                      size: "lg",
                      class: "_tc--accent",
                      "has-base-class": ""
                    }, null, 8 /* PROPS */, ["name", "icon-namespace"])
                  ]),
                  _createElementVNode("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(item.text) + " ", 1 /* TEXT */),
                    (item.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "gfu-link gfu-link--accent"
                        }, [
                          _cache[0] || (_cache[0] = _createTextVNode(" learn more ", -1 /* CACHED */)),
                          _createVNode(_component_base_icon, {
                            name: "chevron-right",
                            size: "sm"
                          })
                        ], 8 /* PROPS */, _hoisted_5))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_base_quote, {
            author: $options.quotes.goOnBoard.author,
            quote: $options.quotes.goOnBoard.text
          }, null, 8 /* PROPS */, ["author", "quote"]),
          _cache[16] || (_cache[16] = _createElementVNode("div", null, [
            _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Want more details? We're happy to share!"),
            _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " Gamefound supports creators of all sizes - whether you're just starting out or already a major player. Here are just a few examples from different segments: ")
          ], -1 /* CACHED */)),
          _createVNode(_component_why_gamefound_project_explorer, { "project-tags": $props.projectTags }, null, 8 /* PROPS */, ["project-tags"]),
          _createVNode(_component_base_quote, {
            author: $options.quotes.gabeBarrett.author,
            quote: $options.quotes.gabeBarrett.text
          }, null, 8 /* PROPS */, ["author", "quote"]),
          _cache[17] || (_cache[17] = _createElementVNode("div", null, [
            _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Feature comparison"),
            _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " Features that set Gamefound apart from the competition. ")
          ], -1 /* CACHED */)),
          _createVNode(_component_platform_feature_comparison),
          _createVNode(_component_base_quote, {
            author: $options.quotes.creativeGameStudio.author,
            quote: $options.quotes.creativeGameStudio.text
          }, null, 8 /* PROPS */, ["author", "quote"]),
          _cache[18] || (_cache[18] = _createElementVNode("div", null, [
            _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Beyond the obvious"),
            _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " How Gamefound actually works for you. ")
          ], -1 /* CACHED */)),
          _createVNode(_component_box, {
            huge: "",
            class: "_grid _grid-cols-1 _grid-cols-2--l _gap-6"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "_flexcol _jc-c" }, [
                _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1 _mb-1" }, "Even 55% better results on Gamefound"),
                _createTextVNode(" Features like Follower Gifts, Stretch Pay, Endgame, and multiple payment methods can significantly boost your campaign's performance — sometimes without you even realizing it. "),
                _createElementVNode("br"),
                _createTextVNode(" This is the kind of extra lift you might not have known was possible. ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", null, [
                _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/perks.svg" })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/reprints.svg" })
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "_flexcol _jc-c" }, [
                _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1 _mb-1" }, "Reprints earn 90% more on Gamefound"),
                _createTextVNode(" Creators often see significant gains on Gamefound when reprinting titles originally launched on Kickstarter. With powerful conversion tools and an engaged community, your next run can outperform your first. ")
              ], -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "_flexcol _jc-c" }, [
                _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1 _mb-1" }, "There's 65% more to come after crowdfunding"),
                _createTextVNode(" On average, creators raise an additional 65% during the Late Pledge and Pledge Manager phases. With Gamefound, your campaign keeps growing even after the main funding ends. ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", null, [
                _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/tree.svg" })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/popup-promo.svg" })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Adfound - the elite marketing tool built into Gamefound", -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createTextVNode(" Reach the right backers at the right time. Adfound supports flexible ad budgeting and tracks performance from pre-launch to post-campaign — helping you grow followers, boost sales, and get more from every ad dollar. ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_button, {
                    theme: "accent",
                    tag: "a",
                    href: $options.performanceMarketingUrl
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Learn more", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"])
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "_flexcol _jc-c _gap-1" }, [
                _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Advanced pledge manager with a proven track record"),
                _createTextVNode(" The pledge manager on Gamefound has been developed since 2016 and is continuously being improved to accommodate all the needs of crowdfunding. It has helped over 1,000 creators deliver more than 2,400 projects worth hundreds of millions of dollars. ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", null, [
                _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/pm.svg" })
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "_col-span-2--l _tac" }, [
                _createElementVNode("h4", { class: "gfu-hd gfu--h3" }, "Thanks to Gamefound's features, your campaign can reach its full potential.")
              ], -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_base_quote, {
            author: $options.quotes.chipTheoryGames.author,
            quote: $options.quotes.chipTheoryGames.text
          }, null, 8 /* PROPS */, ["author", "quote"]),
          _cache[19] || (_cache[19] = _createElementVNode("div", null, [
            _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1" }, "Growth in numbers"),
            _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " A breakdown of our core indicators, year over year - and they speak volumes. ")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/users-graph.svg" }),
            _createVNode(_component_themed_image, { src: "/content/images/static/why-gf/revenue-graph.svg" })
          ]),
          _createVNode(_component_base_quote, {
            author: $options.quotes.hexPloreIt.author,
            quote: $options.quotes.hexPloreIt.text
          }, null, 8 /* PROPS */, ["author", "quote"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_box, null, {
              default: _withCtx(() => [
                _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1 _mb-2" }, "I am ready to try Gamefound", -1 /* CACHED */)),
                _cache[11] || (_cache[11] = _createElementVNode("div", null, " Create a free test campaign and see how Gamefound works — no commitment needed. Explore the features, build your page, and experience the full toolset before you go live. It's the easiest way to get started. ", -1 /* CACHED */)),
                _createVNode(_component_base_button, {
                  tag: "a",
                  href: $options.createCreatorAccountUrl,
                  theme: "accent",
                  class: "_mt-6"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Become a creator ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_box, null, {
              default: _withCtx(() => [
                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h1 _mb-2" }, "Not convinced yet?", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Want to dig deeper before you decide? You can learn more about the platform, explore detailed data, and if you still have questions, feel free to reach out to us via our ", -1 /* CACHED */)),
                  _createElementVNode("a", {
                    href: $props.contactForCreatorsUrl,
                    class: "_tc--accent"
                  }, "contact form", 8 /* PROPS */, _hoisted_10),
                  _cache[13] || (_cache[13] = _createTextVNode(". ", -1 /* CACHED */))
                ]),
                _createVNode(_component_base_button, {
                  tag: "a",
                  href: $options.becomeACreatorUrl,
                  theme: "accent",
                  class: "_mt-6"
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" Learn more ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}